import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '200px',
  padding: '$2',
  textAlign: 'center',
});

export const TitleStyled = styled('span', {
  fontWeight: '$medium',
  marginLeft: '$1',
});

export const ValueStyled = styled('span', {
  fontWeight: '$bold',
});
